import { SfSelectFormField, SfSelectOption } from 'ngx-smart-form';
import { Observable, Subject } from 'rxjs';
import { DEPS_FIELDS } from '../configs/deps-fields';
import { SettoreFieldValue } from './settore-field-value';

export class SagittaScoreElement {
  kriPoint$ = new Subject<number>();
  options?: SfSelectOption[];
  private readonly shouldSubscribeToSettoreFieldChanges: boolean;
  private immobiliareKriWeight: number;
  private altroKriWeight: number;
  constructor(
    public description: string,
    public field: SfSelectFormField,
    public kriPoints: number,
    public kriWeight: number,
    public id: string,
    private sectionWeight: number,
    public selectionValue: string | number | null | undefined
  ) {
    let dep = DEPS_FIELDS.find((el) => el.id === id);
    this.shouldSubscribeToSettoreFieldChanges = !!dep;
    this.immobiliareKriWeight = dep?.immobiliareWeight || 0;
    this.altroKriWeight = dep?.altriWeight || 0;
  }

  init(parentRefValueChange$?: Observable<SettoreFieldValue | undefined>) {
    this.updateKriPoints(this.sectionWeight, this.field.value);
    this.field?.controlRef?.valueChanges.subscribe((val) => {
      this.updateKriPoints(this.sectionWeight, val);
    });

    if (this.shouldSubscribeToSettoreFieldChanges) {
      parentRefValueChange$?.subscribe((val) => {
        if (val) {
          this.reassign(val);
        }
        this.updateKriPoints(this.sectionWeight, this.field.controlRef?.value);
      });
    }
  }

  updateKriPoints(
    sectionWeight: number,
    value: number | (SfSelectOption & { id?: string }) | null | undefined
  ) {
    const parseValue = (
      value:
        | number
        | (SfSelectOption<string> & { id?: string })
        | undefined
        | null
    ) => {
      let numVal: number;
      if (typeof value === 'object') {
        numVal = Number(value?.value);
      } else {
        numVal = value || 0;
      }
      return numVal;
    };
    let numValue = parseValue(value);
    this.kriPoints = this.calcKriPoints(
      Number(numValue),
      this.kriWeight,
      sectionWeight
    );
    this.kriPoint$.next(this.kriPoints);
  }

  protected calcKriPoints(
    value: number | null | undefined,
    kriWeight: number,
    blockWeight: number
  ): number {
    let ctrlValue = value || 0;
    let points = ctrlValue * (kriWeight / 100);
    return points;
  }

  private reassign(val: SettoreFieldValue | undefined) {
    if (val === 'SETTORE IMMOBILIARE') {
      this.kriWeight = this.immobiliareKriWeight;
    } else {
      this.kriWeight = this.altroKriWeight;
    }
  }
}
